import { Box, Container, Typography } from '@mui/material';
import Video from 'components/Video';
import LazyLoad from 'react-lazyload';
import NextLink from 'next/link';
import CustomButton from 'components/CustomButton';
import { useStyles } from './styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export default function BuildPresentations() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor={COLOR_PURPLE} py={6}>
        <Container>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box>
              <Typography className={classes.whiteColor} variant="h4" component="h2">
                <b>
                  Build stunning presentations for <br /> speeches and webinars
                </b>
              </Typography>

              <Box py={4}>
                <Typography className={classes.textDescription} variant="h6" component="p">
                  Create the most amazing presentations for speeches and <br /> webinars in a blink
                  of an eye. Just drag and drop elements <br /> into the workspace to build stunning
                  designs almost instantly. <br /> Save time with Mind the Graph.
                </Typography>
              </Box>

              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton variant="buttonWhiteTextPurple">
                  Create Presentations Faster
                </CustomButton>
              </NextLink>
            </Box>

            <Box className={classes.videoWrapper} ml={10}>
              <LazyLoad offset={50}>
                <Video
                  className={classes.video}
                  sources={[
                    { src: '/videos/new-header-banner-new-workspace.webm', type: 'video/webm' },
                  ]}
                />
              </LazyLoad>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
